import { React, useState, useEffect } from 'react';
import {
  Card,
  Page,
  Layout,
  Button,
  ButtonGroup,
  TextField,
  Text
} from '@shopify/polaris';
import { Helmet } from 'react-helmet';
import { apiFetch, redirectToUrl } from '../../common/Helpers';

function FeedbackSurvey(props) {

  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState(null);
  const [surveyInfo, setSurveyInfo] = useState({
    id: null,
    leftReview: false
  });
  const [submitting, setSubmitting] = useState(false);
  const showReviewSection = rating >= 5 && !surveyInfo.leftReview;
  const ratingIsNotSet = rating == null;

  useEffect(() => {
    apiFetch("api/feedbackSurvey/current")
      .then(response => response.json())
      .then((data) => setSurveyInfo(data));
  }, [])

  const onReview = function () {
    apiFetch("api/feedbackSurvey/registerReviewInitiated",
      {
        method: 'POST'
      });

    redirectToUrl("https://apps.shopify.com/tag-genie#modal-show=WriteReviewModal");
  }

  const onSubmit = function () {
    setSubmitting(true);
    apiFetch("api/feedbackSurvey",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: surveyInfo.id,
          rating: rating,
          comment: comment,
        })
      }).then(() => props.onSurveyCompleted());
  }

  return (
    <div>
      <Helmet>
        <title>Tag Genie - Feedback Survey</title>
      </Helmet>
      <Page title="Feedback Survey"
        subtitle={"Quarterly survey to check how we are doing and how we can improve."}>
        <Layout>
          <Layout.Section>
            <Card title="Rate your Tag Genie experience">
              <Card.Section>
                <p>How happy are you with Tag Genie on a scale from 1 to 5, 1 being not happy at all?</p>
                <ButtonGroup segmented>
                  <Button size="large" pressed={rating === 1} onClick={() => setRating(1)}>🤬 1 </Button>
                  <Button size="large" pressed={rating === 2} onClick={() => setRating(2)}>🙁 2 </Button>
                  <Button size="large" pressed={rating === 3} onClick={() => setRating(3)}>😐 3 </Button>
                  <Button size="large" pressed={rating === 4} onClick={() => setRating(4)}>🙂 4 </Button>
                  <Button size="large" pressed={rating === 5} onClick={() => setRating(5)}>😍 5 </Button>
                </ButtonGroup>
              </Card.Section>
              {showReviewSection && <Card.Section title="Leave a review">
                <p>Would you mind leaving us a review? It will just take a minute</p>
                <p>There is no need to write a long review - simply stating that you are happy with the app (or not) will go a long way.</p>
                <p>Reviews help other people find us on the app store. Leaving a review will help us grow and make the app event better.</p>
                <br />
                <Button size="large" fullWidth primary onClick={onReview}>Leave a review</Button>
              </Card.Section>
              }
              <Card.Section title="How can we improve?">
                <TextField
                  placeholder="Please list any suggestions for new features, improvements, etc. that you might have."
                  onChange={(newValue) => setComment(newValue)}
                  multiline={3}
                  value={comment}
                />
              </Card.Section>
              <Card.Section>
                {ratingIsNotSet && <Text color="critical">Please specify a rating before proceeding</Text>}
                <Button loading={submitting} primary onClick={onSubmit} disabled={ratingIsNotSet}>Submit & Continue to App</Button>
              </Card.Section>
            </Card>
          </Layout.Section>
        </Layout>
      </Page>
    </div>
  );
}


export default FeedbackSurvey;